import axios from "axios";
import { fetchLanguagesSuccess, detectLanguageSuccess } from "../reducers/languageReducer";
import { downloadTranslatedFileSuccess, getTranslationSegmentsSuccess, getFilteredSegmentsSuccess, cancelLoading, loadingFile, loadingEnd, showEditor } from "../reducers/uploadReducer";
import { addDisplayedSegments, segmentsIsLoading, acceptTranslatedSegment } from "../reducers/segments";
import { Base64 } from "js-base64";
import { getText } from "../helpers/heper";
import { validateSegment } from "../reducers/validationReducer";
import { setAnnonymously } from "../reducers/stateManagmentReducer";
import { notify } from "../notify/notify";
import "react-toastify/dist/ReactToastify.css";
import { axiosApiInstance } from "../services/axiosInterceptors";

const baseURL = "https://api.textunited.com/OpenEditor/";
const docProcessor = "https://api.textunited.com/DocProcessor/";
export const oldBaseUrl = "https://www.textunited.com/api/";

export const validationSegment = (segmentData) => async (dispatch) => {
  try {
    const options = {
      method: "POST",
      url: baseURL + "validate",
      headers: {
        "Content-Type": "application/json",
      },

      data: {
        referenceSegment: segmentData.SourceText,
        validatedSegment: segmentData.TargetText,
        segmentState: 200,
        maxLength: null,
      },
    };

    await axiosApiInstance
      .request(options)
      .then((response) => dispatch(validateSegment({ svr: response.data, segmentId: segmentData.segmentId })))
      .catch((error) => console.error(error.message));
  } catch (e) {
    console.log("ERROR", e);
  }
};

export const downloadTranslatedFile = (translatedFile) => async (dispatch) => {
  dispatch(loadingFile());
  try {
    const options = {
      method: "POST",
      url: baseURL + "Json/revert",
      headers: {
        "Content-Type": "application/json",
      },

      data: {
        fileId: translatedFile.fileId,
        transUnits: translatedFile.transUnits,
      },
    };

    await axiosApiInstance
      .request(options)
      .then((response) => dispatch(downloadTranslatedFileSuccess(response.data)))
      .then((data) => getText(data));
  
  } catch (e) {
    console.log("ERROR in COMPLETE FILE");
  }
};

export const getTranslation = (model) => async (dispatch) => {
  dispatch(segmentsIsLoading(true));
  try {
    const options = {
      method: "POST",
      url: baseURL + "MachineTranslation",
      headers: {
        "Content-Type": "application/json",
      },

      data: {
        sourceLanguageId: model.sourceLanguageId,
        targetLanguageId: model.targetLanguageId,
        putTargetOnError: true,
        semgments: model.semgments,
        engine: 0,
      },
    };

    await axiosApiInstance.request(options)
    .then((response) => dispatch(addDisplayedSegments(response.data)))
    .then(() => dispatch(segmentsIsLoading(false)));
  } catch (e) {
    console.log("EROOR in machine translation", e);
  }
};

export const getFilteredSegments = (filters) => async (dispatch) => {
  dispatch(loadingFile());
  try {
    const options = {
      method: "POST",
      //url: baseURL + "Json/convert",
      url: baseURL + "DocProcessor/convert",
      headers: {
        "Content-Type": "application/json",
   
      },

      data: {
        fileId: filters.fileId,
        paragraphSegmentation: false, //filters.paragraphSegmentation,
        tags: filters.tags,
        include: filters.include,
        containsHTML: filters.containsHTML,
        fileName: "file.json"
      },
    };

    axiosApiInstance
      .request(options)
      .then((responce) => dispatch(getFilteredSegmentsSuccess({ filteredSegments: responce.data })))
      .then(() => dispatch(loadingEnd()));
  } catch (e) {
    console.log("Error in LOADING_FILE", e);
  }
};

export const getTranslationSegments = (file) => async (dispatch) => {
  //dispatch(loadingFile());
  try {
    JSON.parse(file);
  } catch (e) {
    notify({ type: "error", text: e.message });
    dispatch(cancelLoading());
    return;
  }

  try {
    const options = {
      method: "POST",
      url: docProcessor + "/convert",
      headers: {
        "Content-Type": "application/json",
        //Authorization: basic,
      },

      data: {
        fileId: null,
        base64File: Base64.encode(file),
        paragraphSegmentation: false,
        tags: ["string"],
        exclude: false,
        containsHTML: true,
        fileName: "file.json",
      },
    };

    axiosApiInstance
      .request(options)
      .then((responce) => dispatch(getTranslationSegmentsSuccess({ segments: responce.data })))
      .then(() => dispatch(showEditor()))
      .catch(() => dispatch(cancelLoading()));
  } catch (e) {
    console.log(e);
  }
};


export const fetchLanguages = () => async (dispatch) => {
  try {
    const languages = await axiosApiInstance({
      method: "get",
      url: baseURL + "Languages",
      headers: {
        "Content-Type": "application/json",

      },
    });
    dispatch(fetchLanguagesSuccess(languages.data));
  } catch (e) {
  }
};

export const langDetection = (text) => async (dispatch) => {
  try {
    const detectedLang = await axiosApiInstance({
      method: "post",
      url: baseURL + "LanguageDetection",
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        text: text,
      },
    });
    dispatch(detectLanguageSuccess(detectedLang.data));
  } catch (e) {
    console.log("ERROR in LANG DETECTION", e);
  }
};

export async function getToken() {
  const data = await axios.post("https://api.textunited.com/authentication/api/AnonymousToken");
  return data;
}

export const getAnnonymousToken = () => async (dispatch) => {
  await axios
    .post("https://api.textunited.com/authentication/api/AnonymousToken")
    .then((response) => {
      sessionStorage.setItem("refresh_token", response.data.refreshToken);
      sessionStorage.setItem("token", response.data.accessToken);
      window.location.href = "https://www.textunited.com/json-free-translator"//"http://localhost:3000";
    })
    .then(() => dispatch(setAnnonymously(true)));
};
